import { Injectable } from "@angular/core";
import * as JsEncryptModule from 'jsencrypt';

@Injectable()
export class RSAEncryptnProvider {
    encryptMod: any;

    constructor() {
        this.encryptMod = new JsEncryptModule.JSEncrypt();
    }

    // Encryption RSA Algorithm -- public key from API - Text which need to convert 
    encryptText(publicKey,textConvert) {
        this.encryptMod.setPublicKey(publicKey);
        return  this.encryptMod.encrypt(textConvert);
    }

    // dencryption RSA Algorithm -- private key from API - Text which need to convert 
    decryptText(privateKey,textConvert) {
        this.encryptMod.setPrivateKey(privateKey);
        return this.encryptMod.decrypt(textConvert);
    }

}


// WEBPACK FOOTER //
// ./src/providers/rsa-encrypt/rsa-encrypt.ts